<template>
  <div class="layout-home">
    <NavBar :loadedPositionsLength="loadedPositionsLength" />
    <MapLarge />
    <template v-if="loadedPositionsLength">
      <MapPositionsIndex />
    </template>
    <template v-if="sidebarPositionIndex">
      <portal to="sidebar-position-index">
        <SidebarPositionIndex />
      </portal>
    </template>
    <template v-if="sidebarAppInfo">
      <portal to="sidebar-app-info">
        <SidebarAppInfo />
      </portal>
    </template>
    <template v-if="sidebarMunicipalitiesIndex">
      <portal to="sidebar-municipalities-index">
        <SidebarMunicipalitiesIndex />
      </portal>
    </template>
    <template v-if="sidebarPositionNew">
      <portal to="sidebar-position-new">
        <SidebarPositionNew />
      </portal>
    </template>
    <template v-if="sidebarPositionSaved">
      <portal to="sidebar-position-saved">
        <SidebarPositionSaved />
      </portal>
    </template>
    <template v-if="sidebarCategoriesIndex">
      <portal to="sidebar-categories-index">
        <SidebarCategoriesIndex />
      </portal>
    </template>
    <template v-if="sidebarPositionEdit">
      <portal to="sidebar-position-edit">
        <SidebarPositionEdit />
      </portal>
    </template>
    <template v-if="modalAddLocation">
      <portal to="simple-modal">
        <ModalAddLocations />
      </portal>
    </template>
  </div>
</template>

<script>
import NavBar from "@/components/Home/NavBar.vue";
import MapLarge from "@/components/Home/MapLarge.vue";
import SidebarAppInfo from "@/components/Home/SidebarAppInfo.vue";
import SidebarMunicipalitiesIndex from "@/components/Home/SidebarMunicipalitiesIndex.vue";
import SidebarPositionNew from "@/components/Home/SidebarPositionNew.vue";
import SidebarPositionSaved from "@/components/Home/SidebarPositionSaved.vue";
import SidebarPositionIndex from "@/components/Home/SidebarPositionIndex.vue";
import SidebarPositionEdit from "@/components/Home/SidebarPositionEdit.vue";
import SidebarCategoriesIndex from "@/components/Home/SidebarCategoriesIndex.vue";
import ModalAddLocations from "@/components/Home/ModalAddLocations.vue";
import MapPositionsIndex from "@/components/Home/MapPositionsIndex.vue";

export default {
  components: {
    NavBar,
    MapLarge,
    SidebarAppInfo,
    SidebarMunicipalitiesIndex,
    SidebarPositionNew,
    SidebarPositionSaved,
    SidebarPositionIndex,
    SidebarPositionEdit,
    SidebarCategoriesIndex,
    ModalAddLocations,
    MapPositionsIndex
  },
  computed: {
    loadedPositions() {
      return this.$store.state.data.loadedPositions;
    },
    sidebarAppInfo() {
      return this.$store.state.ui.sidebarAppInfo;
    },
    sidebarMunicipalitiesIndex() {
      return this.$store.state.ui.sidebarMunicipalitiesIndex;
    },
    sidebarPositionNew() {
      return this.$store.state.ui.sidebarPositionNew;
    },
    sidebarPositionSaved() {
      return this.$store.state.ui.sidebarPositionSaved;
    },
    sidebarPositionIndex() {
      return this.$store.state.ui.sidebarPositionIndex;
    },
    sidebarPositionEdit() {
      return this.$store.state.ui.sidebarPositionEdit;
    },
    sidebarCategoriesIndex() {
      return this.$store.state.ui.sidebarCategoriesIndex;
    },
    modalAddLocation() {
      if (
        !this.sidebarAppInfo &&
        !this.sidebarMunicipalitiesIndex &&
        !this.sidebarPositionNew &&
        !this.sidebarPositionSaved &&
        !this.loadedPositionsLength
      ) {
        return this.$store.state.ui.modalAddLocation;
      } else {
        return false;
      }
    },
    loadedPositionsLength() {
      let value = false;
      if (this.loadedPositions) {
        if (this.loadedPositions.data.length > 0) {
          value = true;
        }
      }
      return value;
    }
  }
};
</script>

<style scoped lang="scss">
.layout-home {
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
}
</style>
